import React from 'react';
import GenericPullAndPushToolView from '../GenericPullAndPushToolView';
import DataTheoremConfigListing from './DataTheoremConfigListing';
import DataTheoremCredentialForm from './DataTheoremCredentialForm'

export default function DataTheoremPullAndPushView(props){
    return (
        <GenericPullAndPushToolView
            {...props}
            PullCredentialForm={DataTheoremCredentialForm}
            PullConfigListingView={DataTheoremConfigListing}
         />
    )
}